import styled from "styled-components";
import { Variables } from "../../Variables";

export const ContainerBackForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 2px 20px;
  margin: 10px 0;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(10px);
  border: 1px solid ${Variables.colorGrayBack};
  border-radius: 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.7);
`;

export const ContainerGlobal = styled.div`
  @import url("https://fonts.googleapis.com/css2?family=Inter&display=swap");
  @import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@700&display=swap");
  position: relative;
  width: 99.3vw;
  height: 100vh;
  align-self: center;
  background-image: url("/imageBackHealth.png");
  background-repeat: no-repeat;
  background-size: cover;

  @media (max-height: 650px) {
    height: auto;
  }
`;

export const ContainerReverse = styled.div`
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;

  @media (max-width: ${Variables.maxLaptops}) {
    flex-direction: column-reverse;
    width: 100%;
  }

  @media (max-width: ${Variables.maxTablet}) {
    margin: 0;
    flex-direction: column-reverse;
  }
`;

export const TopText = styled.div`
  margin-top: 1%;
  text-align: center;
  font-family: "Inter", sans-serif;
  color: ${Variables.colorRed};

  @media (max-width: ${Variables.maxLaptops}) {
    font-size: 12px;
    margin: 20px 5px;
  }
`;

export const Header = styled.div`
  position: relative;
  width: 100%;
  height: 360px;
  background-image: url("/backgroundStepHealth.png");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;

  @media (max-width: ${Variables.maxLaptops}) {
    margin: 0;
    width: 100%;
    height: 292px;
  }

  @media (max-width: ${Variables.maxTablet}) {
    margin: 0;
    width: 100%;
    height: 206px;
    background-image: url("/backgroundStepHealthMobile.png");
  }
`;

export const ContainerStep = styled.div`
  position: absolute;
  right: 1%;
  top: 26%;
  width: 28%;

  @media (max-width: ${Variables.maxLaptops}) {
    top: 24%;
    right: 1%;
    width: 30%;
  }

  @media (max-width: ${Variables.maxTablet}) {
    top: 15%;
    right: 5%;
    width: 36%;
  }
`;

export const TextStep = styled.p`
  font-size: 20px;
  font-weight: 700;
  font-family: "Montserrat", sans-serif;
  text-align: right;
  color: ${Variables.colorBlackDark};

  @media (max-width: ${Variables.maxLaptops}) {
    font-size: 18px;
  }

  @media (max-width: ${Variables.maxTablet}) {
    font-size: 11px;
  }
`;

export const TextStepOrange = styled.span`
  color: ${Variables.colorOrange};
`;

export const ContainerVideoAndInfo = styled.div`
  position: absolute;
  bottom: 10%;
  left: 14%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 20px;
  width: 30%;

  @media (max-width: ${Variables.maxLaptops}) {
    left: 8%;
    width: 35%;
  }

  @media (max-width: ${Variables.maxTablet}) {
    top: 63%;
    left: 0%;
    bottom: auto;
    margin: 0 5%;
    grid-column-gap: 20px;
    width: 90%;
  }
`;

export const ContainerOptions = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  cursor: pointer;

  :hover {
    border-bottom: 2px solid ${Variables.colorBlackDark};
  }
`;

export const TextOptions = styled.p`
  font-size: 16;
  font-weight: 700;
  font-family: "Montserrat", sans-serif;
  color: ${Variables.colorBlackDark};

  @media (max-width: ${Variables.maxLaptops}) {
    font-size: 13px;
  }
`;

export const ContainerBack = styled.div`
  position: absolute;
  top: 5%;
  left: 2%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 9%;
  cursor: pointer;

  :hover {
    border-bottom: 2px solid ${Variables.colorWhite};
  }

  @media (max-width: ${Variables.maxTablet}) {
    top: 1%;
    width: 10%;
  }

  @media (max-width: ${Variables.maxTablet}) {
    top: 1%;
    width: 18%;
  }
`;

export const TextBack = styled.p`
  font-size: 24px;
  font-weight: 700;
  font-family: "Montserrat", sans-serif;
  color: ${Variables.colorWhite};

  @media (max-width: ${Variables.maxLaptops}) {
    font-size: 13px;
  }
`;

export const NameFile = styled.p`
  text-align: center;
`;
export const LeftDiv = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 460px;
  height: 100vh;

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const StyledImageBackground = styled.img`
  width: 100%;
  height: 100%;
`;

export const ContainerTextBold = styled.div`
  margin-top: 20px;
  padding: 20px;
  border: 1px solid ${Variables.colorCeleste};
  border-radius: 30px;
`;

export const RightDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-left: 450px;
  background-color: white;

  @media (max-width: 1024px) {
    margin-left: 0;
  }
`;

export const TopSection = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 40px;
  width: 80%;

  & p {
    cursor: pointer;
  }
`;

export const TextContainer = styled.section`
  margin: 0;
  width: 100%;

  & h1 {
    font-size: 40px;
    font-weight: 500;
  }

  & p {
    margin-top: 16px;
    margin-bottom: 16px;
    color: ${Variables.colorBlack};
  }
`;

export const BackDiv = styled.div`
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const Back = styled.a`
  position: absolute;
  margin-top: 3px;
  margin-left: 10px;
  font-size: 16px;
  font-weight: 400;
  color: ${Variables.colorGray};
`;

export const _ContainerGlobal = styled.div`
  padding: 2% 2%;
  background-color: ${Variables.colorWhite};
`;

export const ContentForms = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const DataCenter = styled.div`
  width: 80%;
  margin-bottom: 30px;

  @media (max-width: 1633px) {
    width: 95%;
  }
`;

export const HeaderForm = styled.div`
  padding: 2.5%;
  width: 95%;
  border-radius: 30px;
  font-weight: bold;
  background-color: #f9b233;
  text-align: center;
  color: #1d1d1b;
`;
export const HeaderFormWhite = styled.div`
  padding: 25px;
  width: 100%;
  border-radius: 30px;
  font-size: 1.2em;
  font-weight: bold;

  text-align: center;
  color: #f9b233;
`;
export const SearchBox = styled.div`
  display: flex;
  justify-content: space-around;

  align-items: center;
  flex-direction: column;

  margin: 10px;
  padding: 25px;

  width: 100%;
  height: 300px;
  background-color: #d7dae1;
`;
export const AnimationLoading = styled.div`
  display: inline-block;
  width: 80px;
  height: 80px;

  & :after {
    content: " ";
    display: block;
    margin: 8px;
    width: 64px;
    height: 64px;
    border: 6px solid ${Variables.colorPrimary};
    border-radius: 50%;
    border-color: ${Variables.colorPrimary} transparent ${Variables.colorPrimary} transparent;
    animation: lds-dual-ring 1.2s linear infinite;
  }

  @keyframes lds-dual-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
export const HeaderFormBlue = styled.div`
  margin-top: 20px;
  padding: 2.5%;
  width: 95%;
  border-radius: 30px;
  font-weight: bold;
  background-color: #282d3e;
  text-align: center;
  color: #ffffff;
`;

export const ContainerBar = styled.img`
  align-items: center;
  width: 40%;
`;

export const Footer = styled.div`
  padding-bottom: 100px;
`;

export const ImgLeft = styled.img`
  width: 100px;
  height: 140px;
`;
export const ContainerForm = styled.img`
  padding: 10px;
`;

export const ImgIcon = styled.img`
  width: 25px;
  height: 25px;
`;

export const ContainerTitle = styled.div`
  width: 70%;
`;

export const TextH3 = styled.span`
  color: ${Variables.colorRed};
`;
export const TextBold = styled.h3`
  margin-bottom: 10px;
  width: 100%;
  font-size: 17px;
  font-weight: 500;
  color: ${Variables.colorBlackDark};

  @media (max-width: ${Variables.maxLaptops}) {
    font-size: 16px;
  }
`;
export const TextInformative = styled.h3`
  margin-bottom: 8px;
  width: 100%;
  font-size: 1.5em;
  font-weight: bold;
  text-align: center;
`;
export const ContainText = styled.div`
  box-sizing: border-box;
  padding: 10px;
  width: 100%;
  border-radius: 20px;
  background-color: ${Variables.colorOrange};
`;
export const TextBar = styled.p`
  text-align: center;
  font-weight: bold;
  color: ${Variables.colorBlackDark};
`;

export const ContainerInputs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: row;
  width: 100%;

  @media (max-width: 820px) {
    flex-direction: column;
    align-items: center;
  }
`;
export const ContainerInput = styled.div`
  position: relative;
  margin: 10px 0;
  width: 32%;

  @media (max-width: 820px) {
    width: 95%;
  }
`;

export const ContainerInputFile = styled.div`
  position: relative;
  width: 32%;
  height: 53px;

  @media (max-width: 820px) {
    width: 95%;
  }
`;

export const TextInfo = styled.div`
  font-size: 25px;
  color: ${Variables.colorBlackDark};
  font-weight: 600;
`;

export const ContainerTextMail = styled.div`
  /* padding-bottom: 20px; */
  align-items: center;

  @media (max-width: 820px) {
    flex-direction: column;
  }
`;

export const ErrorCaptcha = styled.div`
  padding: 5px 10px;
  border: 2px solid ${Variables.colorRedBorder};
  border-radius: 5px;
  background-color: ${Variables.colorRedBackError};
`;
export const TextBoldRed = styled.h3`
  margin-top: 20px;
  width: 100%;
  font-size: 1.2em;
  font-weight: bold;
  text-align: center;

  color: #fe1010;
`;

export const _TextStep = styled.h3`
  font-weight: 500;
  text-align: center;
  color: ${Variables.colorOrange};
`;

export const ContainerSteps = styled.div`
  margin: 50px 15%;
  width: 70%;
`;

export const ContainCard = styled.div`
  display: flex;
  flex-direction: row;
  margin: 30px 0;

  && :hover {
    opacity: 0.8;
    border: 1px solid ${Variables.colorGray};
    cursor: pointer;
  }
`;
export const ImageStep = styled.img`
  width: 200px;
  height: 200px;
`;

export const ContainerContent = styled.div`
  align-self: center;
  margin: 0 30px;
  width: 50%;
`;
export const ImageStep1 = styled.img`
  width: 300px;
  height: 100px;
`;

export const ImageStep2 = styled.img`
  width: 300px;
  height: 50px;
`;

export const TitleCard = styled.h4`
  font-weight: 400;
  color: ${Variables.colorRed};
`;

export const TextObjetive = styled.h4`
  font-weight: 400;
  color: ${Variables.colorGray};
`;

export const ContainerTerms = styled.div`
  display: flex;
`;

export const InfoTerms = styled.div`
  margin-left: 20px;
  cursor: pointer;
`;

export const ImageTable = styled.img`
  width: 100%;
`;

export const TitleSisben = styled.h2`
  margin-bottom: 40px;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  color: ${Variables.colorGreenSuccess};
`;

export const InfoTexts = styled.div`
  font-size: 20px;
  font-weight: 500;
`;

export const textsA = styled.a`
  text-decoration: none;
  color: ${Variables.colorRedDark};
`;
